export const environment = {
  production: true,
  appUrl: '/api/',
  hubUrl: '/hub',
  i18nUrl: '',
  baseUrl: '',
  appId: 'zvelton_Backoffice',
  defaultPage: 'HomePage',
  windowsAuthentication: false,
  semanticVersion: '1.0.15'
};